import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_COST_CENTER,
  CREATE_COST_CENTER,
  DELETE_COST_CENTER,
  UPDATE_COST_CENTER,
} from './actionType';

import {
  CostCenterApiResponseSuccess,
  CostCenterApiResponseError,
} from './action';

import {
  getCostCenter as costCenterGet,
  createCostCenter as costCenterCreate,
  updateCostCenter as costCenterUpdate,
  deleteCostCenter as costCenterDelete,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getCostCenter() {
  try {
    const response = yield call(costCenterGet);
    yield put(CostCenterApiResponseSuccess(GET_COST_CENTER, response));
  } catch (error) {
    yield put(CostCenterApiResponseError(GET_COST_CENTER, error));
  }
}

function* createCostCenter(data) {
  try {
    const response = yield call(costCenterCreate, data.payload.data);
    yield put(CostCenterApiResponseSuccess(CREATE_COST_CENTER, response));
    notifySuccess('Centro de custo criado com sucesso!');
  } catch (error) {
    yield put(CostCenterApiResponseError(CREATE_COST_CENTER, error));
    notifyError('Erro ao criar centro de custo!');
  }
}

function* updateCostCenter(data) {
  try {
    const response = yield call(costCenterUpdate, {
      id: data.payload.id,
      data: data.payload.data,
    });
    yield put(CostCenterApiResponseSuccess(UPDATE_COST_CENTER, response));
    notifySuccess('Centro de custo atualizado com sucesso!');
  } catch (error) {
    yield put(CostCenterApiResponseError(UPDATE_COST_CENTER, error));
    notifyError('Erro ao atualizar o centro de custo!');
  }
}

function* deleteCostCenter(data) {
  try {
    const response = yield call(costCenterDelete, data.payload.id);
    yield put(CostCenterApiResponseSuccess(DELETE_COST_CENTER, response));
    notifySuccess('Centro de custo deletado com sucesso!');
  } catch (error) {
    yield put(CostCenterApiResponseError(DELETE_COST_CENTER, error));
    notifyError('Erro ao deletar o centro de custo!');
  }
}

export function* watchGetCostCenter() {
  yield takeEvery(GET_COST_CENTER, getCostCenter);
}

export function* watchCreateCostCenter() {
  yield takeEvery(CREATE_COST_CENTER, createCostCenter);
}

export function* watchUpdateCostCenter() {
  yield takeEvery(UPDATE_COST_CENTER, updateCostCenter);
}

export function* watchDeleteCostCenter() {
  yield takeEvery(DELETE_COST_CENTER, deleteCostCenter);
}

function* CostCenterSaga() {
  yield all([fork(watchGetCostCenter)]);
  yield all([fork(watchCreateCostCenter)]);
  yield all([fork(watchUpdateCostCenter)]);
  yield all([fork(watchDeleteCostCenter)]);
}

export default CostCenterSaga;
